import { withStyles } from '@glu/theming';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useCallback } from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles = {
  root: {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    border: 0
  }
};

var AccessibilityText = function AccessibilityText(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["classes", "children"]);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("p", _extends({
      className: classes.root
    }, rest), children)
  );
};

AccessibilityText.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired
};
var AccessibilityTextBase = AccessibilityText;
var AccessibilityText$1 = withStyles(styles)(AccessibilityText);

/**
 * Delay the passed function for delays milliseconds to debounce user input
 * @param {function} fn - The function to trigger after the timeout is complete
 * @param {number} delay - The length of time to wait in milliseconds
 */
var debounce = function debounce(fn, delay) {
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(void 0, args);
    }, delay);
  };
};

var IE = 'Internet Explorer';
var OPERA = 'Opera';
var CHROME = 'Chrome';
var FIREFOX = 'Firefox';
var EDGE_CHROMIUM = 'Edge (Chromium)';
var EDGE_HTML = 'Edge (HTML)';
var SAFARI = 'Safari';
var OTHER = 'Other';
var DEFAULT_ALLOW_LIST = [{
  name: CHROME
}, {
  name: FIREFOX
}, {
  name: EDGE_CHROMIUM
}];

/**
 * Compares each part of a version number to confirm if allowed
 * supports decimals and any number of semver parts
 * @param allowedVersion
 * @param currentVersion
 * @returns {boolean}
 */

var checkVersionAllowed = function checkVersionAllowed(allowedVersion, currentVersion) {
  var allowedParts = allowedVersion.toString().split('.');
  var currentParts = currentVersion.toString().split('.');

  if (allowedParts.length !== currentParts.length) {
    return false;
  } else {
    // eslint-disable-next-line no-plusplus
    for (var i = 0; allowedParts.length > i; i++) {
      var allowedPart = parseInt(allowedParts[i], 10);
      var currentPart = parseInt(currentParts[i], 10);

      if (allowedPart > currentPart) {
        return false;
      } else if (allowedPart < currentPart) {
        return true;
      }
    }

    return true;
  }
};
var getBrowserByUA = function getBrowserByUA() {
  var _navigator;

  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent;

  if (userAgent.indexOf('Edge') > -1) {
    return {
      name: EDGE_HTML,
      version: /Edge\/([0-9.]+)/.exec(userAgent)[1]
    };
  } else if (userAgent.indexOf('Edg') > -1) {
    return {
      name: EDGE_CHROMIUM,
      version: /Chrome\/([0-9.]+)/.exec(userAgent)[1]
    };
  } else if (userAgent.indexOf('OPR') > -1) {
    return {
      name: OPERA,
      version: userAgent.substring(userAgent.indexOf('OPR') + 4)
    };
  } else if (userAgent.indexOf('Chrome') > -1) {
    return {
      name: CHROME,
      version: /Chrome\/([0-9.]+)/.exec(userAgent)[1]
    };
  } else if (userAgent.indexOf('Trident') > -1) {
    var rv = userAgent.indexOf('rv:');
    return {
      name: IE,
      version: userAgent.substring(rv + 3, userAgent.indexOf('.', rv))
    };
  } else if (userAgent.indexOf('Firefox') > -1) {
    return {
      name: FIREFOX,
      version: /Firefox\/([0-9.]+)/.exec(userAgent)[1]
    };
  } else if (userAgent.indexOf('Safari') > -1) {
    var safariOffset = userAgent.indexOf('Safari');
    var versionOffset = userAgent.indexOf('Version');
    var version = userAgent.substring(safariOffset + 7);

    if (versionOffset !== -1) {
      var _userAgent$substring$ = userAgent.substring(versionOffset + 8).split(' ');

      var _userAgent$substring$2 = _slicedToArray(_userAgent$substring$, 1);

      version = _userAgent$substring$2[0];
    }

    return {
      name: SAFARI,
      version: version
    };
  } else {
    return {
      name: 'Other',
      version: "".concat(parseFloat(navigator.appVersion))
    };
  }
};
var isBrowserSupportedByUA = function isBrowserSupportedByUA() {
  var _navigator2;

  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.userAgent;
  var allowList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ALLOW_LIST;
  var currentBrowser = getBrowserByUA(userAgent);
  return allowList.filter(function (allow) {
    if (allow.name === currentBrowser.name) {
      return allow.version ? checkVersionAllowed(allow.version, currentBrowser.version) : true;
    } else {
      return false;
    }
  }).length === 1;
};

/* istanbul ignore file */
var defaultStrings_enUS = {};

var parseFetchResponse = function parseFetchResponse(response) {
  return new Promise(function (resolve, reject) {
    if (response.status === 204) {
      resolve({
        response: response,
        data: null
      });
      return;
    }

    var contentType = response.headers.get('Content-Type');
    var isJSON = contentType && contentType.indexOf('json') > -1;
    (isJSON ? response.json() : response.text()).then(function (content) {
      if (!response.ok) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({
          error: content,
          response: response
        });
        return;
      }

      resolve({
        data: content,
        response: response
      });
    });
  });
};

var useClickOutside = function useClickOutside(ref, onClickOutside) {
  useEffect(function () {
    var handleClick = function handleClick(event) {
      if (ref && ref.current && !ref.current.contains(event.target)) onClickOutside();
    };

    var handleKeyDown = function handleKeyDown(event) {
      if (event.keyCode === 27) {
        // Escape
        onClickOutside();
      }
    };

    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClickOutside, ref]);
  return ref;
};

/**
 * Loads data and returns the results
 * @param {RequestInfo} url - The url string or Request object
 * @param {Object} [fetchOptions] - Options to `fetch`
 * @param {Object} [options] - Extra values
 * @param {function} [options.parse = {@see parseFetchResponse}] - Response parser
 * @param {boolean} [options.wait] - Prevents fetch from running
 * @param {Array} [options.inputs] - Additional parameters to watch to rerun the fetch
 * @returns {{ isLoading: boolean, data: any, response: any, failure: any, error: any }}
 */

var useFetch = function useFetch(url, fetchOptions) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$parse = _ref.parse,
      parse = _ref$parse === void 0 ? parseFetchResponse : _ref$parse,
      wait = _ref.wait,
      _ref$inputs = _ref.inputs,
      inputs = _ref$inputs === void 0 ? [] : _ref$inputs;

  var _useState = useState(!wait),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      result = _useState4[0],
      setResult = _useState4[1];

  useEffect(function () {
    var ignore = false;

    if (wait) {
      return;
    }

    setLoading(true);
    fetch(url, fetchOptions).then(parse).then(function (_ref2) {
      var data = _ref2.data,
          response = _ref2.response;

      if (ignore) {
        return;
      }

      setResult({
        data: data,
        response: response
      });
      setLoading(false);
    })["catch"](function (rejects) {
      if (ignore) {
        return;
      }

      if (rejects.response) {
        setResult({
          error: rejects.error,
          response: rejects.response
        });
      } else {
        setResult({
          failure: rejects
        });
      }

      setLoading(false);
    }); // eslint-disable-next-line consistent-return

    return function () {
      ignore = true;
    };
  }, [url, fetchOptions, wait, parse].concat(_toConsumableArray(inputs)));
  return _objectSpread2({
    isLoading: isLoading
  }, result);
};

/**
 * Accepts @media rule and returns boolean depends of the actual window size,
 * on load and if user resizes their screen.
 * @param {string} query e.g. - '(min-width: 768px) and (max-width: 1279px)'
 * @returns {boolean}
 */

var useMediaQuery = function useMediaQuery(query) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      match = _useState2[0],
      setMatch = _useState2[1];

  useEffect(function () {
    var updateMatch = function updateMatch() {
      return setMatch(window.matchMedia(query).matches);
    };

    updateMatch();
    window.matchMedia(query).addEventListener('change', updateMatch);
    return function () {
      window.matchMedia(query).removeEventListener('change', updateMatch);
    };
  }, [query]);
  return match;
};

var defaultParse = function defaultParse(value) {
  return value;
};
/**
 * Runs a promise and returns its results and a `running` flag
 * @param {Object} options
 * @param {function} options.init - A function that returns a promise
 * @param {boolean} [options.wait] - Prevents any promises from running
 * @param {function} [options.parseResolves] - Formats the resolved value on success
 * @param {function} [options.parseRejects = parseResolves] - Formats the reject value on failure
 * @param {Array} [options.inputs] - Additional parameters to watch to rerun the promise
 * @returns {{ running: boolean, resolves: any, rejects: any }}
 */


var usePromise = function usePromise(_ref) {
  var init = _ref.init,
      wait = _ref.wait,
      _ref$parseResolves = _ref.parseResolves,
      parseResolves = _ref$parseResolves === void 0 ? defaultParse : _ref$parseResolves,
      _ref$parseRejects = _ref.parseRejects,
      parseRejects = _ref$parseRejects === void 0 ? parseResolves : _ref$parseRejects,
      _ref$inputs = _ref.inputs,
      inputs = _ref$inputs === void 0 ? [] : _ref$inputs;

  var _useState = useState(!wait),
      _useState2 = _slicedToArray(_useState, 2),
      running = _useState2[0],
      setRunning = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      resolves = _useState4[0],
      setResolves = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      rejects = _useState6[0],
      setRejects = _useState6[1];

  useEffect(function () {
    var ignore = false;

    if (wait) {
      return;
    }

    setRunning(true);
    init().then(parseResolves).then(function (result) {
      if (ignore) {
        return;
      }

      setResolves(result);
      setRejects(null);
      setRunning(false);
    })["catch"](function (error) {
      Promise.resolve(error).then(parseRejects).then(function (result) {
        if (ignore) {
          return;
        }

        setResolves(null);
        setRejects(result);
        setRunning(false);
      });
    }); // eslint-disable-next-line consistent-return

    return function () {
      ignore = true;
    };
  }, [init, wait, parseResolves, parseRejects].concat(_toConsumableArray(inputs)));
  return {
    resolves: resolves,
    rejects: rejects,
    running: running
  };
};

var sessionStorageSave = function sessionStorageSave(key, data) {
  return new Promise(function (resolve, reject) {
    try {
      sessionStorage.setItem(key, JSON.stringify(data));
      resolve();
    } catch (e) {
      sessionStorage.removeItem(key);
      reject(e);
    }
  });
};

var sessionStorageRead = function sessionStorageRead(key) {
  var data = sessionStorage.getItem(key);

  if (!data) {
    return Promise.resolve(null);
  } // Only handling valid JSON


  var retrieved = null;
  var results = new Promise(function (resolve, reject) {
    try {
      retrieved = JSON.parse(data);
    } catch (e) {
      sessionStorage.removeItem(key);
      reject(e);
    }

    resolve(retrieved);
  });
  return results;
};
/**
 * Checks storage and returns value and ability to set storage.
 *
 * @param {Object} options
 * @param {string} options.storageId - Key for the session.
 * @param {function} [options.save] - Saves data to storage. Expects promise.
 * @param {function} [options.read] - Reads data. Expects promise that returns a value.
 * @returns {Array} - First item is value data. Second item is setter function.
 *    Third item is any read errors the function catches.
 */


function useStorage(_ref) {
  var storageId = _ref.storageId,
      _ref$save = _ref.save,
      save = _ref$save === void 0 ? sessionStorageSave : _ref$save,
      _ref$read = _ref.read,
      read = _ref$read === void 0 ? sessionStorageRead : _ref$read;

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setSession = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      readError = _useState4[0],
      setReadError = _useState4[1];

  var readSessionData = useCallback(function () {
    read(storageId).then(function (results) {
      setReadError(null);
      setSession(results);
    })["catch"](setReadError);
  }, [storageId, read]);
  useEffect(function () {
    readSessionData();
  }, [readSessionData]);

  var setValue = function setValue(data) {
    return save(storageId, data);
  };

  return [value, setValue, readError];
}

var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];

var getFocusableChildren = function getFocusableChildren(el) {
  return el.querySelectorAll(focusableElements.join(', '));
};

var getFocusedChild = function getFocusedChild(focusableChildren) {
  var currentFocus;

  try {
    currentFocus = document.activeElement;
  } catch (err) {
    /* istanbul ignore next */
    var _focusableChildren = _slicedToArray(focusableChildren, 1);

    currentFocus = _focusableChildren[0];
  }

  return currentFocus;
};

var useTrapFocus = function useTrapFocus(_ref) {
  var ref = _ref.ref,
      active = _ref.active;
  return function (e) {
    if (e.which !== 9 || !ref.current || !active) return;
    var focusableChildren = getFocusableChildren(ref.current);
    var totalFocusable = focusableChildren.length;
    if (totalFocusable === 0) return;
    var currentFocus = getFocusedChild(focusableChildren);
    var focusedIndex = 0;

    for (var i = 0; i < totalFocusable; i += 1) {
      if (focusableChildren[i] === currentFocus) {
        focusedIndex = i;
        break;
      }
    }

    if (e.shiftKey && focusedIndex === 0) {
      e.preventDefault();
      focusableChildren[totalFocusable - 1].focus();
    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
      e.preventDefault();
      focusableChildren[0].focus();
    }
  };
};

export { AccessibilityText$1 as AccessibilityText, AccessibilityTextBase, debounce, isBrowserSupportedByUA, getBrowserByUA, defaultStrings_enUS as defaultStrings, parseFetchResponse, useClickOutside, useFetch, useMediaQuery, usePromise, useStorage, useTrapFocus, IE, OPERA, CHROME, FIREFOX, EDGE_CHROMIUM, EDGE_HTML, SAFARI, OTHER, DEFAULT_ALLOW_LIST };
